export enum ValueType {
  'none' = 'none',
  'all' = 'all',
  'some' = 'some',
  'bound' = 'bound',
  'fromStylesheet' = 'fromStylesheet'
}